<template>
    <v-card tile :loading="loading">
        <div class="card-title">
            {{ $t('Apps') }}
        </div>
        <v-card-text>
            <v-row class="pa-2">
                <v-col v-for="app in apps" :key="app.workflowId" cols="12" sm="6" md="4" lg="3" class="d-flex">
                    <v-card outlined class="app-card d-flex flex-column flex-grow-1 rounded-lg">
                        <div class="d-flex align-center pa-4 pb-2">
                            <v-avatar tile rounded size="46" color="primary" class="me-3 rounded-lg flex-shrink-0">
                                <v-icon class="white--text">{{ app.icon || 'mdi-sitemap' }}</v-icon>
                            </v-avatar>
                            <h3 class="app-title" :title="app.title">{{ app.title }}</h3>
                        </div>

                        <div class="px-4 pb-3 d-flex align-center text-caption grey--text text--darken-1">
                            <span>{{ $t('InitiatedWorkflows') }}</span>
                            <v-chip x-small color="secondary" label class="ms-2 font-weight-bold">{{ app.runningFlows }}</v-chip>
                        </div>

                        <v-spacer></v-spacer>
                        <v-divider></v-divider>
                        <v-card-actions class="px-2">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-on="on" v-bind="attrs" icon color="primary"
                                           :to="{ name: 'workflow-designer', query: { id: app.workflowDefinitionId } }">
                                        <v-icon>mdi-lead-pencil</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('Edit') }}</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-on="on" v-bind="attrs" icon color="warning" @click="setPermissions(app.workflowId)">
                                        <v-icon>mdi-shield-account</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('Permissions') }}</span>
                            </v-tooltip>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
        <CommonDialog v-model="permissionDialog" v-if="permissionDialog" :title="$t('Permissions')" :fullscreen="false" width="35%" css-content-class="pa-0" @input="$emit('input', false)">
            <v-container fluid class="stretch">
                <GenericPermissions :itemId="selectedItem" @close="permissionDialog = false" :typeId="typeId"></GenericPermissions>
            </v-container>
        </CommonDialog>
    </v-card>
</template>

<script>
    import ProcessesService from '@/services/ProcessesService.js'
    import GenericPermissions from '@/components/app/admin/GenericPermissions.vue'
    import { PermissionTypesEnum } from '@/helpers/constants/enumerations'
    import CommonDialog from '@/components/controls/CommonDialog.vue'

    export default {
        components: {
            CommonDialog, GenericPermissions
        },

        data() {
            return {
                loading: false,
                apps: [],
                selectedItem: null,
                permissionDialog: false,
                typeId: PermissionTypesEnum.Process,
            }
        },
        created() {
            this.listWorkflows()
        },

        methods: {
            listWorkflows() {
                this.loading = true
                ProcessesService.listProcesses()
                    .then(res => {
                        if (res.data) {
                            this.apps = res.data
                        }
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },

            setPermissions(itemId) {
                this.selectedItem = itemId
                this.permissionDialog = true
            }
        }
    }
</script>

<style scoped>
    .app-card {
        transition: box-shadow .2s ease, transform .2s ease, border-color .2s ease;
    }
    .app-card:hover {
        box-shadow: 0 6px 20px rgba(0, 0, 0, .12) !important;
        border-color: var(--v-primary-base, #1B8354);
        transform: translateY(-2px);
    }
    .app-title {
        font-size: 15px;
        font-weight: 600;
        line-height: 1.35;
        margin: 0;
        /* clamp long Arabic titles to 2 lines so every card stays the same height */
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-word;
    }
</style>